<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getProducto } from '@/services/configurations/getProducto'
import { getHistoricalByProduct } from '@/services/historical/getHistoricalByProduct'
import { getHistoricalByProductExcel } from '@/services/historical/getHistoricalByProductExcel'

export default {
  name: 'list-trash-product-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 70,
      vuexnamespace: 'trashHistoricalProducts',
      headerUrl: 'trash/products/details',
      breadcrumbs: [
        { url: 'trash/products', name: i18n.t('trash.header') },
        { url: 'trash/products', name: i18n.t('trash.products') },
        {
          paths: ['ItemDescription'],
          routeCallback: this.descRouteCallback,
        },
      ],
      ExcelName: `${_.kebabCase(i18n.t('products.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idProducto: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return { ...this.getParamsAux(data), borrado: true }
    },
    getDetalleAux: async function (params) {
      return await getProducto(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByProductExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByProduct(payload, params)
    },
    descRouteCallback: function (data, elthis, breadcrumb) {
      return { path: '', name: elthis.truncate(data, 30, false) }
    },
  }
}
</script>

<style lang="scss" scoped></style>
